let userInfo = JSON.parse(localStorage.getItem("userinfo"));
let initListItem;
function isTzrb() {
  let flag = false;
  let type = userInfo ? userInfo.userType : "";
  if (type == 2) flag = true;
  return flag;
}
function isTzzj() {
  let flag = false;
  let type = userInfo ? userInfo.userType : "";
  if (type == 6) flag = true;
  return flag;
}
function isEmptyObj(obj) {
  return JSON.stringify(obj) === "{}";
}
if (userInfo && !isEmptyObj(userInfo)) {
  if (isTzzj()) {
    initListItem = {
      name: "dashboard",
      path: "/dashboard",
    };
  } else if (isTzrb()) {
    initListItem = {
      path: "/home/index",
      name: "homeIndex",
    };
  } else {
    initListItem = {
      path: "/home/tisindex",
      name: "homeTisindex",
    };
  }
}
const state = {
  list: initListItem ? [initListItem] : [],
};
const getters = {};

const actions = {};

const mutations = {
  initList(state) {
    let userInfo = JSON.parse(localStorage.getItem("userinfo"));
    let initListItem;
    function isTzrb() {
      let flag = false;
      let type = userInfo ? userInfo.userType : "";
      if (type == 2) flag = true;
      return flag;
    }
    function isTzzj() {
      let flag = false;
      let type = userInfo ? userInfo.userType : "";
      if (type == 6) flag = true;
      return flag;
    }
    function isEmptyObj(obj) {
      return JSON.stringify(obj) === "{}";
    }
    if (userInfo && !isEmptyObj(userInfo)) {
      if (isTzzj()) {
        initListItem = {
          name: "dashboard",
          path: "/dashboard",
        };
      } else if (isTzrb()) {
        initListItem = {
          path: "/home/index",
          name: "homeIndex",
        };
      } else {
        initListItem = {
          path: "/home/tisindex",
          name: "homeTisindex",
        };
      }
    }
    state.list = [initListItem];
  },
  add(state, obj) {
    var isAdd = true;
    state.list.forEach((item) => {
      // console.log(item);
      // console.log(obj);

      if (item.path == obj.path) {
        isAdd = false;
      }
    });
    if (isAdd && obj.path != "/") {
      state.list.push(obj);
    }
    // !state.list.includes(name) && state.list.push(name)
  },
  remove(state, path) {
    state.list = state.list.filter((v) => {
      return v.path != path;
    });
  },
  clean(state) {
    // let userInfo = JSON.parse(localStorage.getItem("userinfo"));
    // let initListItem;
    // function isTzrb() {
    //   let flag = false;
    //   let type = userInfo ? userInfo.userType : "";
    //   if (type == 2) flag = true;
    //   return flag;
    // }
    // function isTzzj() {
    //   let flag = false;
    //   let type = userInfo ? userInfo.userType : "";
    //   if (type == 6) flag = true;
    //   return flag;
    // }
    // if (userInfo) {
    //   if (isTzzj()) {
    //     initListItem = {
    //       name: "dashboard",
    //       path: "/dashboard",
    //     };
    //   } else if (isTzrb()) {
    //     initListItem = {
    //       path: "/home/index",
    //       name: "homeIndex",
    //     };
    //   } else {
    //     initListItem = {
    //       path: "/home/tisindex",
    //       name: "homeTisindex",
    //     };
    //   }
    // }
    state.list = [
      // initListItem,
      //   {
      //     name: "dashboard",
      //     path: "/dashboard",
      //   },
    ];
  },
};
// mutations.initList();

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
